const EnterpriseComponent = () => import('@/views/enterprise/EnterpriseView')

export default [
    {
        path:'/EnterpriseIndex',
        name:'EnterpriseIndex',
        component:EnterpriseComponent
    }
]